export default "__VITE_ASSET__9ba68508__"